import { atom } from 'jotai';

export const learnMoreModalOpenedAtom = atom(false);
